define('view/controller/booking/datetime/flexible/TimeFlexibleHourItemView',['require','lib/view/LayoutView','lib/Utils'],function (require) {

    var LayoutView = require('lib/view/LayoutView');
    var Utils = require('lib/Utils');

    /**
     * Time flexible item view
     *
     * @class TimeFlexibleItemView
     */
    return LayoutView.extend({

        template: '#time_flexible_hour_item_view',
        
        triggers: _.extend({
            'click': 'select:time',
        }, Utils.ifParams(!Utils.isIos(), {
            'mouseenter': 'hover:time'
        })),
        
        modelEvents: {
            'change': 'render'
        },

        serializeData: function () {
            var result = LayoutView.prototype.serializeData.apply(this);
            result.time_diff = this.getOption('clientTimeZone').get('time_diff');

            return result;
        }

    });

});
